import React from "react";
import {
  GridColumnMenuCheckboxFilter,
  GridColumnMenuSort,
} from "@progress/kendo-react-grid";
import { orderBy, get } from "lodash";
import moment from "moment";
import { KENDO_DATE_FORMAT } from "src/constants";
import { Box, Tooltip } from "@material-ui/core";
import FilterIcon from "Assets/images/grid-filter.svg";

export const sortFilterData = (colProps, data) => {
  if (get(colProps, "column.filter") === "date") {
    return [...data].sort((a, b) =>
      get(colProps, "sort.0.dir", "") === "desc"
        ? moment(a[get(colProps, "column.field")], KENDO_DATE_FORMAT) -
          moment(b[get(colProps, "column.field")], KENDO_DATE_FORMAT)
        : moment(b[get(colProps, "column.field")], KENDO_DATE_FORMAT) -
          moment(a[get(colProps, "column.field")], KENDO_DATE_FORMAT)
    );
  }
  return orderBy(data, `${get(colProps, "column.field")}`);
};

export const columnFilterSort = (columnProps, gridData) => {
  const sortedData = sortFilterData(columnProps, gridData);
  return (
    <div>
      <GridColumnMenuSort {...columnProps} />
      <GridColumnMenuCheckboxFilter
        {...columnProps}
        data={sortedData}
        searchBoxFilterOperator={"contains"}
      />
    </div>
  );
};

export const headerCell = (props) => (
  <Box display={"flex"} justifyContent={props?.align ? props?.align : "center"}>
    <Tooltip title={get(props, "title", "")}>
      <span className={"k-link"} onClick={props.onClick}>
        {get(props, "title", "")}
        {props?.headerClassName ? (
          <img src={FilterIcon} alt="filter" className="ml10 v-middle" />
        ) : (
          ""
        )}
        {props.children}
      </span>
    </Tooltip>
  </Box>
);
